const image = {
  logo: require("./asset/Geomagic-Logo.webp"),
  hero_bg: require("./asset/hero_section.webp"),
  vid_shape: require("./asset/circle.webp"),

  icon_1: require("./asset/icon_1.webp"),
  icon_2: require("./asset/icon_2.webp"),
  icon_3: require("./asset/icon_3.webp"),
  icon_4: require("./asset/icon_4.webp"),
  icon_5: require("./asset/icon_5.webp"),

  star: require("./asset/star-3.webp"),
  circle1: require("./asset/ellipse-4.webp"),
  circle2: require("./asset/ellipse-6.webp"),
  poly: require("./asset/polygon-5.webp"),
  title_bg: require("./asset/title_bg.webp"),

  pro_kit: require("./asset/Geomagic_Pro_Kit.webp"),
  circle: require("./asset/Geomagic_Circle_Edition.webp"),
  basic: require("./asset/Geomagic_Basic_Edition.webp"),
  mini: require("./asset/Goemagic_Mini.webp"),
  circle_mini: require("./asset/Geomagic_Circle_Mini.webp"),
  basic_mini: require("./asset/Geomagic_Basic_Mini.webp"),

  img1: require("./asset/gallery_1.webp"),
  img2: require("./asset/gallery_2.webp"),
  img3: require("./asset/gallery_3.webp"),
  img4: require("./asset/gallery_4.webp"),
  img5: require("./asset/gallery_5.webp"),
  img6: require("./asset/gallery_6.webp"),
  img7: require("./asset/gallery_7.webp"),
  img8: require("./asset/gallery_8.webp"),
  img9: require("./asset/gallery_9.webp"),
  img10: require("./asset/gallery_10.webp"),

  contact: require("./asset/contact.webp"),
};

export default image;
